import {useAuthStore} from '@frontend/stores'
import type {UserData} from '@frontend/types'
import {
    type DependencyList,
    useEffect,
} from 'react'

// Выполнить функцию после загрузки данных пользователя в useAuthStore().
export function useEffectOnUserDataLoaded(
    callback: (user: UserData | null) => void,
    deps: DependencyList = []
) {
    const setOnUserDataLoaded = useAuthStore(
        state => state.setOnUserDataLoaded
    )

    // Загрузка данных продавца при монтировании.
    useEffect(() => {
        setOnUserDataLoaded(callback)
    }, deps)
}
